import { render, staticRenderFns } from "./ListBimbingan.vue?vue&type=template&id=0b0a25ba"
import script from "./ListBimbingan.vue?vue&type=script&lang=js"
export * from "./ListBimbingan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports